import Events from './Events.redux';

export default Events;
